package org.hs_soft.runmynesto.domain.usecase.options.printer_locatoin

import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_restaurant.printer_location.PrinterLocationModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.printer_location.UpdatePrinterLocationRepository


class UpdatePrinterLocationUseCase
    (private val repository: UpdatePrinterLocationRepository) {
    suspend operator fun invoke(
        printerLocation:List<String?>,
    ): PrinterLocationModel {
        return repository.updateKitchenLocation(printerLocation)
    }

    fun cancel(){
        repository.cancel()
    }
}